import { Box, Flex, SimpleGrid } from '@chakra-ui/react';
import { Avatar, Tag, Text } from '@kula-ai/components';
import type { DashboardCard } from '../../../types';
import { tone } from './tone';

// Fixed 3-up grid: stable card width, equal height per row. A short row leaves
// its trailing columns empty rather than widening the cards.
export const CardGrid = ({ cards }: { cards: DashboardCard[] }) => (
  <SimpleGrid columns={3} spacing="12px">
    {cards.map((c, i) => {
      const accent = c.tone ? tone(c.tone) : null;
      return (
        <Box
          key={`${c.title}-${i}`}
          minW="0"
          border="1px solid"
          borderColor={accent ? `${c.tone}-300` : 'border-color'}
          borderRadius="10px"
          bg="base-white"
          px="12px"
          py="10px"
        >
          <Flex align="center" gap="8px" minW="0">
            <Avatar src={c.logo} name={c.title} shape="square" size={22} />
            <Text variant="h4" truncate title={c.title}>
              {c.title}
            </Text>
          </Flex>
          {c.body && (
            <Text variant="p" style={{ display: 'block', marginTop: 2 }}>
              {c.body}
            </Text>
          )}
          {c.detail && (
            <Text
              variant="p"
              className="text-[12px] text-secondary-500"
              style={{ display: 'block', marginTop: 2 }}
            >
              {c.detail}
            </Text>
          )}
          {c.tags && c.tags.length > 0 && (
            <Flex wrap="wrap" gap="4px" mt="6px">
              {c.tags.map((t) => (
                <Tag key={t} label={t} size="sm" variant="outline" />
              ))}
            </Flex>
          )}
        </Box>
      );
    })}
  </SimpleGrid>
);
